// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__7edcS","pulse":"styles_pulse__TWhjG","jump":"styles_jump__MxIsp"};